import { render, staticRenderFns } from "./formPassword.vue?vue&type=template&id=20639828&scoped=true&"
import script from "./formPassword.vue?vue&type=script&lang=js&"
export * from "./formPassword.vue?vue&type=script&lang=js&"
import style0 from "./formPassword.vue?vue&type=style&index=0&id=20639828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20639828",
  null
  
)

export default component.exports